// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__ZCqi_","footer__logo":"footer_footer__logo__OTQQn","footer__logo-text":"footer_footer__logo-text___L91u","inner":"footer_inner__MF6W5"};